module.exports = "/_next/static/images/blibli-b7cd37d9d354daab6f8de8dc8c2c26a6.svg";